import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M80 15V5H60V0H50v5H30V0H20v5H0v75h10v20h90V15zm-70 0h10v6.5h10V15h20v6.5h10V15h10v15H10zm60 25v30H10V40zm20 50H20V80h60V25h10z" }, null, -1)
  ]))]))
}
export default { render: render }